import { default as WJElement } from '../wje-element/element.js';
import ButtonGroup from './button-group.element.js';

// export * from "./button-group.element.js";
export default ButtonGroup;

WJElement.define('wje-button-group', ButtonGroup);
